import React, { useState, useEffect, useRef } from "react";

import { API_URL, getValFromLS } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Msg from "../components/Msg";
import Button from "../components/Button";

import Upload from "./Upload";
import Uploading from "./Uploading";
import Uploaded from "./Uploaded";

import "./styles.css";

const Batch = () => {
	const [status, setStatus] = useState(3);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	/* Status
    0 - Error
    1 - Uploaded
    2 - Uploading
    3 - Idle
  */

	const formElement = useRef(null);

	useEffect(() => {
		init(getValFromLS("vtoUserToken") || "");
	}, []);

	const init = async (token) => {
		const url = new URL(`${API_URL}/auth/batchInit`);
		const params = {
			token,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	useEffect(() => {
		if (names.file) {
			formElement.current.dispatchEvent(new Event("submit"));
		}
	}, [names.file]);

	const handleUpdate = (name, value) => {
		if (name === "file") {
			if (value.size > 5000000) {
				setMsg({
					type: "error",
					text: "Please limit upload size to 5 MB.",
				});
				return false;
			} else {
				setStatus(2);
				setNames((names) => ({ ...names, [name]: value }));
			}
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		const url = new URL(`${API_URL}/auth/batch1`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleUpdate("records", json.records);
				handleUpdate("uploadedFileName", json.uploadedFileName);
				setStatus(1);
			} else {
				setStatus(3);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setStatus(3);
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleReset = () => {
		setMsg({});
		setStatus(3);
		setNames({});
	};

	return (
		<div id="full-column" style={{ minHeight: "100%" }}>
			<Hdg section="Batch Donations Upload" />
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div className="donate-charity-box">
						<div style={{ paddingBottom: "15px" }}>
							<div className="full">
								<h3>
									Use this page to perform a batch upload of CfC donations
								</h3>

								<p style={{ marginBottom: "0" }}>
									The file processing script will attempt to validate the
									following attributes.
								</p>

								<ul style={{ marginTop: "15px", marginBottom: "0" }}>
									<li>
										Check that any included Donation IDs and Charity Codes are
										valid
									</li>
									<li>Check Donation column values are valid dollar amounts</li>
									<li>
										Check the appropriate donation Attribution and Tax Receipt
										values are present
									</li>
									<li>Check valid syntax of any included email addresses</li>
									<li>Check valid dates for Date Submitted and Date Paid</li>
								</ul>

								<p style={{ marginBottom: "0" }} className="notice">
									For new donation batches that have more that 50 email
									addresses, consider breaking up the file, as generating and
									sending the email receipt can be a slow process.
								</p>
							</div>
						</div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well upload-form"
						>
							<h3 style={{ marginTop: "0" }}>Upload Batch File</h3>

							{status === 2 ||
								(status === 3 && (
									<p style={{ marginBottom: "20px" }}>
										Click the upload icon below to initate the CfC batch
										donations file upload and analyze your data attributes.
									</p>
								))}

							<div className="upload-box">
								{status === 2 ? (
									<Uploading />
								) : status === 3 ? (
									<Upload update={handleUpdate} />
								) : null}
							</div>
							{status === 1 && (
								<Uploaded
									records={names.records}
									uploadedFileName={names.uploadedFileName}
									msg={setMsg}
								/>
							)}

							{msg.type && (
								<div>
									<Msg data={msg} />
									<Button
										label={"Reset Upload Form"}
										iconLeft={"fa-refresh"}
										name="copyLink"
										click={handleReset}
									/>
								</div>
							)}
						</form>
					</div>
				</>
			)}
		</div>
	);
};

export default Batch;
